module.exports = __webpack_public_path__ + "static/media/Bedienungsanleitung.8545caa9.pdf";